import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterSpacing } from "projects/myupdates/src/app/footer/footer-spacing";

import '@datev/dacks/content';

@Component({
    selector: 'dp-download-details-layout',
    templateUrl: './download-details-layout.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [RouterOutlet, FooterSpacing]
})
export class DownloadDetailsLayoutComponent {

}
